<template>
  <div style="width: 100vw;display: flex;flex-direction: row;justify-content:center;align-items:flex-start;">
    <div style="margin-right: 12px;">
      <div style="color: #515151;">color</div>
      <el-color-picker color-format="hex" v-model="color" show-alpha :predefine="predefineColors" @active-change="changeColor" />
    </div>
    <div style="margin-right: 12px;">
      <div style="color: #515151;">font</div>
      <el-dropdown trigger="click" @command="changeFont">
        <el-button round style="margin-bottom: 12px;">
          {{ font }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="(item, index) in fonts" :key="'font' + index" :command="item" :style="{ fontFamily: item }">{{ item }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div style="margin-right: 12px;">
      <div style="color: #515151;">font style</div>
      <el-dropdown trigger="click" @command="changeFontStyle">
        <el-button round style="margin-bottom: 12px;">
          {{ fontStyle }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="(item, index) in fontStyles" :key="'font' + index" :command="item">{{ item }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fonts: ['Arial', 'Archivo Black', 'PT Sans Narrow', 'PT Serif'],
      fontStyles: ['Normal', 'Bold', 'Italic', 'Bold Italic'],
      font: 'Arial',
      fontStyle: 'Normal',
      predefineColors: [
        '#ffffff',
        'rgba(221, 221, 221, 1)',
        'rgba(170, 170, 170, 1)',
        'rgba(0, 0, 0, 1)',
        'rgba(0, 31, 63, 1)',
        'rgba(0, 116, 217, 1)',
        'rgba(127, 219, 255, 1)',
        'rgba(57, 204, 204, 1)',
        'rgba(61, 153, 112, 1)',
        'rgba(46, 204, 64, 1)',
        'rgba(255, 220, 0, 1)',
        'rgba(255, 133, 27, 1)',
        'rgba(255, 65, 54, 1)',
        'rgba(133, 20, 75, 1)',
        'rgba(240, 18, 190, 1)',
        'rgba(177, 13, 201, 1)'
      ],
      color: '#ffffff'
    }
  },
  methods: {
    changeFont (e) {
      this.font = e
      this.$emit('change', { valueProp: 'fontFamily', value: e })
    },
    changeFontStyle (e) {
      this.fontStyle = e
      this.$emit('change', { valueProp: 'fontStyle', value: e.toLowerCase() })
    },
    changeColor (val) {
      if (!val) return
      this.$emit('change', { valueProp: 'fill', value: val.replace('#', '0x') })
    },
    init (target) {
      this.font = target.text.style.fontFamily
      this.fontStyle = target.text.style.fontStyle
      this.color = target.text.style.fill.replace('0x', '#')
    }
  }
}
</script>

<style lang="scss">
.el-color-picker__icon {
  display: none;
}
</style>
